export default {"src":"/_next/static/media/thinking.mono.3e13e078.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};